export default function convertToLowerCase(string) {
    if (string) {
        return string.toLowerCase();
    } else {
        return "";
    }
}
